import { render, staticRenderFns } from "./DraggableSpeechBubble.vue?vue&type=template&id=9fc250dc&scoped=true"
import script from "./DraggableSpeechBubble.vue?vue&type=script&lang=ts"
export * from "./DraggableSpeechBubble.vue?vue&type=script&lang=ts"
import style0 from "./DraggableSpeechBubble.vue?vue&type=style&index=0&id=9fc250dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc250dc",
  null
  
)

export default component.exports